export default __webpack_public_path__ + "static/media/internet-of-things.286371b5.png";